import React from 'react';
import {defaultBreakPoints, defaultLabelSuffix} from "../utils";
import RequiredInfo from "../../../Common/RequiredInfo";
import HelpIcon from "../../../Common/HelpIcon";
import {Grid} from "@material-ui/core";
import useStyles from "./styles";

export default function FormFieldLabel(props) {
    const {
        field,
        fieldConfig: {
            label, fieldLabelBreakPoints, description, descriptionHTML, upperDescriptionHTML,
            validations, suffix, tooltip, tooltipStyle, fieldLabelTextStyle
        }
    } = props;
    const classes = useStyles();
    const isRequired = validations && validations.includes('required');
    const labelBreakPoints = {...defaultBreakPoints.label, ...fieldLabelBreakPoints};
    const labelSuffix = suffix || defaultLabelSuffix;

    return <Grid item {...labelBreakPoints}>
        {upperDescriptionHTML && <div id={`${field}_description`} dangerouslySetInnerHTML={upperDescriptionHTML}/>}
        <div className={classes.labelContainer}>
        {isRequired && <div className={classes.requiredContainer}><RequiredInfo mode="asterisk"/> </div>}
        <label htmlFor={`${field}_input`} className={classes.label} style={fieldLabelTextStyle}>{label}{labelSuffix}</label>
        {tooltip && <HelpIcon tooltip={tooltip} tooltipStyle={tooltipStyle}/>}
        </div>
        {descriptionHTML && <div id={`${field}_description`} dangerouslySetInnerHTML={descriptionHTML}/>}
        {description && <div id={`${field}_description`}>{description}</div>}
    </Grid>
};